import {
    RETRIEVE_FAQ,
    CREATE_FAQ,
    UPDATE_FAQ,
    DELETE_FAQ,
    RESTORE_FAQ,
    UPDATE_FAQ_STATUS,
} from "../actions/types";
  
  const initialState = { faq : [], totalFAQCount : 0 };

const faqReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_FAQ:
      return {
        faq: payload.rows,
        totalFAQCount: payload.count,
      };

    case CREATE_FAQ:
      return payload;

    case UPDATE_FAQ:
      return payload;

    case UPDATE_FAQ_STATUS:
      return {
        faq: payload.rows,
        totalFAQCount: payload.count,
      };

    case DELETE_FAQ:
      return {
        faq: payload.rows,
        totalFAQCount: payload.count,
      };

    case RESTORE_FAQ:
      return {
        faq: payload.rows,
        totalFAQCount: payload.count,
      };

    default:
      return state;
  }
};

export default faqReducer;